const VERSION_KEY = process.env.REACT_APP_VERSION_KEY || 'kf-app-version';

const VersionService = {
  getVersion: (): string | undefined => {
    const version = localStorage.getItem(VERSION_KEY);

    if (version === null) return undefined;
    return version;
  },

  setVersion: (version: string): string | null => {
    localStorage.setItem(VERSION_KEY, version);

    return localStorage.getItem(VERSION_KEY);
  },
};
export default VersionService;
